import { branchConstants } from '../constants';
import { branchService } from '../../services';

export const branchActions = {
  branchesList,
  addBranch,
  getBranch,
  updateBranch
}

/*
ACTION: Branches List
*/
function branchesList(pageID, perPage, searchInput) {
  return dispatch => {
    dispatch(request());
    return branchService.branchesList(pageID, perPage, searchInput)
      .then(
        response => {
          console.log(response);
          dispatch(success(response.data.body.branches, response.data.body.data.total));
        },
        error => {
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: branchConstants.GETALL_REQUEST } }
  function success(items, total) { return { type: branchConstants.GETALL_SUCCESS, items, total } }
  function failure(error) { return { type: branchConstants.GETALL_FAILURE, error } }
}

/*
ACTION: Add Branch
*/
function addBranch(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return branchService.addBranch(formData)
      .then(
        response => {
          addToast('عملیات با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: branchConstants.ADD_REQUEST } }
  function success(status) { return { type: branchConstants.ADD_SUCCESS, status } }
  function failure(error) { return { type: branchConstants.ADD_FAILURE, error } }
}

/*
ACTION: Get Branch By ID
*/
function getBranch(branchID) {
  return dispatch => {
    dispatch(request());
    return branchService.getBranch(branchID)
      .then(
        response => {
          console.log(response);
          dispatch(success(response.data.body));
        },
        error => {
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: branchConstants.GET_REQUEST } }
  function success(item) { return { type: branchConstants.GET_SUCCESS, item } }
  function failure(error) { return { type: branchConstants.GET_FAILURE, error } }
}

/*
ACTION: Update Branch
*/
function updateBranch(addToast, formData) {
  return dispatch => {
    dispatch(request());
    return branchService.updateBranch(formData)
      .then(
        response => {
          addToast('بروزرسانی با موفقیت انجام شد.', { appearance: "success", autoDismiss: true });
          dispatch(success(true));
        },
        error => {
          if(typeof error === 'object') {
            Object.keys(error).map(key => {
              addToast(error[key], { appearance: 'error', autoDismiss: true });
            })
          } else {
            addToast('خطا در برقراری اتصال با سرور!', { appearance: 'error', autoDismiss: true });
          }
          dispatch(failure(error));
        }
      )
  }

  function request() { return { type: branchConstants.UPDATE_REQUEST } }
  function success(status) { return { type: branchConstants.UPDATE_SUCCESS, status } }
  function failure(error) { return { type: branchConstants.UPDATE_FAILURE, error } }
}